export default "__VITE_ASSET__BY2ZN3Ez__"